class ExtensionHelper {
    static EXTENSIONS = {
        MAILGUN: 'mailgun'
    }
}

export default ExtensionHelper;